export default __webpack_public_path__ + "static/media/ic_cloud_light_rain.e05d829b.svg";